//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect } from 'react';
// import './style.scss'
import { useStore } from '../../store/store';
import { MultiCheck } from '../../components/ui/multi-check/MultiCheck';
import { MultiOption } from '../../components/ui/multi-check/Option';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const habits = useStore((state) => state.habits);
  const setHabits = useStore((state) => state.setHabits);
  const [next, setNext] = useState(habits.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    if (habits.length >= 2 && habits.includes('None of the above')) {
      setNext(false);
    }
  }, []);

  const handleChange = (value) => {
    if (value.includes('None of the above')) {
      if (value.length === 1) {
        setNext(true);
        onNext();
      } else {
        setNext(false);
        return;
      }
      setNext(false);
    }
    setHabits(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.habits.title')}</Title>
      </div>

      <div className={'controls'} style={{ marginBottom: 70 }}>
        <MultiCheck defaultValue={habits} onChange={handleChange}>
          <MultiOption value={'I like vine'}>
            <span>🍷</span> {t('onboarding.habits.options.vine')}
          </MultiOption>
          <MultiOption value={'I eat late at night'}>
            <span>🌙</span> {t('onboarding.habits.options.late')}
          </MultiOption>
          <MultiOption value={'sweet tooth'}>
            <span>🧁</span> {t('onboarding.habits.options.tooth')}
          </MultiOption>
          <MultiOption value={'I get snack attaсks'}>
            <span>🍪</span> {t('onboarding.habits.options.snack')}
          </MultiOption>
          <MultiOption value={'I cant live without soda'}>
            <span>🥤</span> {t('onboarding.habits.options.soda')}
          </MultiOption>
          <MultiOption value={'I like crunchy'}>
            <span>🥨</span> {t('onboarding.habits.options.crunchy')}
          </MultiOption>
          <MultiOption value={'I mix screen time with mealtime'}>
            <span>💻</span> {t('onboarding.habits.options.mealtime')}
          </MultiOption>
          <MultiOption value={'None of the above'}>
            <span>🙅‍♀️</span> {t('onboarding.habits.options.none')}
          </MultiOption>
        </MultiCheck>
        <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.habits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'habits',
              answer: habits.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
